import { FormattedMessage } from "react-intl";
import { LabelLangJSON } from "component/LabelLang/label-lang";
import Mailto from "component/shared/mailto";

export default function AdditionalOfficeCard({
  dir,
  titleId,
  office,
  showTitle = true,
}) {
  return (
    <div className="cont-info-item">
      {showTitle && titleId && (
        <h5>
          <FormattedMessage id={titleId} />
        </h5>
      )}
      <span>
        <LabelLangJSON
          id="officeName"
          defaultValue={office.officeName}
          translations={office.elementTranslations}
        />
      </span>
      <h6 dir="rtl" className={dir === "rtl" ? "text-end" : "text-start"}>
        {office.phoneNumber}
      </h6>
      <Mailto email={office.mail}>
        <h6>{office.mail}</h6>
      </Mailto>
    </div>
  );
}
